import { truncateText } from './truncate-text';

export const DEFAULT_MAX_LEGEND_LABEL_WIDTH = 90;

export const truncateLegendLabel = (
  label: string,
  maxWidth: number = DEFAULT_MAX_LEGEND_LABEL_WIDTH
): string => {
  if (!label || typeof label !== 'string') {
    return String(label ?? '');
  }

  return truncateText({
    text: label,
    maxWidth,
    fontSize: 11,
    fontFamily: '"Source Sans Pro", sans-serif',
  });
};

export const createLegendLabelFormatter = (
  maxWidth: number = DEFAULT_MAX_LEGEND_LABEL_WIDTH
) => {
  return (label: string) => truncateLegendLabel(label, maxWidth);
};
